export default __webpack_public_path__ + "static/media/polygon.d413b77e.svg";